// TODO - remove lint disable when editing this file
/* eslint-disable */
import { omit } from 'lodash'
import { Map } from 'immutable'

import arcId from '~/util/arc-identifiers'
import AtomicBaseConverter from './AtomicBaseConverter'
import ConverterContext from '../util/ConverterContext'
import { ToHTMLConverter } from '../util/toHTML'
import { sanitizeText } from '../util/draftUtils'

const HEADER_TYPE = 'table-th'

const sanitizeOptions = {
  keepBodySoftbreaks: true,
}

export const _appendRow = (cells, type, tableContext, rowIndex = 0) => {
  cells.forEach((cell, cellIndex) => {
    let block
    let appendedBlocks
    if (cell.content) {
      const draftBlockData = tableContext.toDraftBlock(
        sanitizeText(cell.content),
        null,
        null,
        sanitizeOptions
      )
      if (draftBlockData.contentBlocks) {
        block = draftBlockData.contentBlocks[0]
      }
    }

    if (block) {
      appendedBlocks = tableContext.appendBlock(block.set('type', type))
    } else {
      appendedBlocks = tableContext.appendEmptyBlock(type)
    }

    // Set metaData, so we can map back proper cell id if table structure gets modified
    tableContext.setAnsElementMetaData(
      appendedBlocks[0].getKey(),
      Map({
        rowIndex,
        cellIndex,
      })
    )
  })
}

export default class TableConverter extends AtomicBaseConverter {
  constructor() {
    super('table', ['atomic-ellipsis.table'])
    this._htmlConverter = new ToHTMLConverter()
    this._htmlConverter.addDefaultMiddleware()
  }

  appendAndGetBlocks(element, context) {
    const tableContext = new ConverterContext()
    element.header && _appendRow(element.header, HEADER_TYPE, tableContext)
    element.rows &&
      element.rows.forEach((tds, index) => {
        // Index 0 is the 1st row which is the odd row
        // Since Draft groups blocks base on the same wrapper value of the block type,
        // we switch between odd and even types to build the table row structure
        const rowType = 'table-td-' + (index % 2 ? 'even' : 'odd')
        _appendRow(tds, rowType, tableContext, index)
      })

    const draftContent = tableContext.generateDraftContent(false)
    return context.appendAtomicBlock(
      Object.assign({}, element, {
        contentState: draftContent.get('contentState'),
      })
    )
  }

  toAnsDataFromBlocks(contentState, [block]) {
    const rawAns = super.toAnsDataFromBlocks(contentState, [block])
    if (rawAns && rawAns.contentState) {
      const ansData = omit(rawAns, ['contentState'])
      const blockMapAsArray = rawAns.contentState.getBlockMap().toArray()
      const header = []
      const rows = []
      let cellMetaData
      let cellType
      let nextCell
      let row = []
      let isExistingCell
      blockMapAsArray.forEach((block, index) => {
        cellMetaData = block.getData()
        isExistingCell = !!cellMetaData && !cellMetaData.isEmpty()
        cellType = block.getType()
        if (cellType === HEADER_TYPE) {
          header.push({
            type: 'text',
            _id: isExistingCell
              ? rawAns.header[cellMetaData.get('cellIndex')]._id
              : arcId.create(),
            content: block.getText()
              ? this._htmlConverter.convert(block, true)
              : '',
          })
        } else {
          row.push({
            type: 'text',
            _id: isExistingCell
              ? rawAns.rows[cellMetaData.get('rowIndex')][
                  cellMetaData.get('cellIndex')
                ]._id
              : arcId.create(),
            content: block.getText()
              ? this._htmlConverter.convert(block, true)
              : '',
          })

          nextCell = blockMapAsArray[index + 1]
          if (!nextCell || cellType !== nextCell.getType()) {
            if (row.length) {
              rows.push(row)
            }
            row = []
          }
        }
      })

      ansData.header = header
      ansData.rows = rows
      return ansData
    }

    return rawAns
  }
}
